import './styles/InputErrorMessage.scss';

import { useClassHelper } from '../../hooks';
import { appTypes } from '../../types/common';

type Props = {
  error?: boolean;
  errorMessage?: string;
  id?: string;
  className?: string;
  app?: keyof typeof appTypes;
  dataCyError?: string; // Added for e2e testing purposes
};

const componentName = 'c-InputErrorMessage';

export const InputErrorMessage = ({
  error,
  errorMessage,
  id,
  app = appTypes.portal,
  dataCyError,
}: Props) => {
  const c = useClassHelper(componentName);

  if (error && errorMessage) {
    return (
      <p
        data-testid="input-error-message"
        id={id}
        className={`${componentName} ${c(`-${app}`)}`}
        data-cy={`${dataCyError}-error`}
      >
        {errorMessage}
      </p>
    );
  }

  return null;
};
